<template>
    <div style='position:relative;'>
        <v-card>
            <!-- Developer Tool & Add Prompt section -->
            <div :class="$style.targetSurveyEditorTools">
                <v-switch :hide-details="true" class="mx-5" v-model="promptDeveloperMode">
                    <template slot="label">
                        Developer Tool
                        <v-tooltip bottom color="black">
                            <template v-slot:activator="{on, attrs}">
                                <v-icon style="margin-left: 5px" color="black" small v-bind="attrs" v-on="on">fas
                                    fa-info-circle</v-icon>
                            </template>
                            <span>
                                It is available to Developers only
                            </span>
                        </v-tooltip>
                    </template>
                </v-switch>

                <v-btn small color="primary" depressed class="mx-5" @click="add_prompt()">
                    Add a Prompt
                </v-btn>
            </div>

            <!-- Prompt Trash Section -->
            <div style="text-align: right; margin: 15px 50px 0 0; padding-bottom: 30px;">
                <!-- Promp Trash -->
                <v-menu offset-y nudge-left='50'>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            x-small
                            icon
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            :disabled="prompt_trash.length === 0"
                            >
                            <div :class="$style.promptTrashSection">
                                <v-badge right>
                                    <template v-slot:badge>
                                        <span>{{prompt_trash.length}}</span>
                                    </template>
                                    <svgIcon :src="trashIcon" />
                                </v-badge>
                                <span :class="$style.promptTrashLabel">Prompt Trash</span>
                            </div>
                        </v-btn>
                    </template>
                    <v-list v-if="prompt_trash.length > 0">
                        <draggable class="list-group" :list="prompt_trash" group="prompts" >
                            <v-list-item v-for="(item, index) in prompt_trash" :key="'trash_prompt_'+index">
                                <div style="border-bottom: 1px solid lightgrey;">
                                    <h3>Name: {{item.name}}</h3>
                                </div>
                            </v-list-item>
                        </draggable>
                    </v-list>
                </v-menu>
            </div>

            <!-- Prompt Section -->
            <div :class="$style.list_container">
                <div style="width: 100%;">
                    <!-- Prompts Draggable Section -->
                    <draggable :list="items" :group="'prompts'" handle=".handle" :class="[{[$style.emptyPromptWrapper]: items.length == 0}, 'list-group']">
                        <template v-for="(prompt,prompt_index) in items">
                            <div :class="$style.prompt_item" :key="'prompt_'+prompt_index">
                                <!-- Prompts Draggable Icon -->
                                <aside :class="[$style.promptItemDragSection, 'handle']">
                                    <svgIcon :src="dragIcon" />
                                </aside>

                                <!-- Prompts Expansion Panels -->
                                <main :class="$style.promptItemMainSection">
                                    <v-icon 
                                        @click="removePrompt(prompt_index);"
                                        color="black" 
                                        small 
                                        :class="$style.deleteIcon">
                                        fa fa-times-circle
                                    </v-icon>
                                    <v-expansion-panels>
                                        <v-expansion-panel class="custom-icon-rotation">
                                            <v-expansion-panel-header expand-icon="fas fa-angle-right">
                                                <span style="font-size: 1.2rem; color: black;">{{prompt.name}}</span>
                                            </v-expansion-panel-header>

                                            <v-expansion-panel-content :class="$style.promptExpansionContentSection">
                                                <div>
                                                    <!-- Prompt Name Input -->
                                                    <div style="width: 65%;">
                                                        <p style="margin-bottom: 0px;">Prompt Name</p>
                                                        <v-text-field v-model="prompt.name" outlined hide-details />
                                                    </div>

                                                    <div v-if="prompt.name" style="position: relative;">

                                                        <!-- Prompt Suppress Switch -->
                                                        <v-switch v-model='prompt.suppress'
                                                            label="Supress - For background behvaiour" hide-details class='mb-2'/>

                                                        <!-- Prompt Execute function  -->
                                                        <template v-if="promptDeveloperMode">
                                                            <v-textarea
                                                                outlined
                                                                :label="'Execute function on trigger = (questionMap, language, component)'"
                                                                v-model="prompt.onTrigger" />
                                                        </template>

                                                        <!-- Prompt TItle -->
                                                        <div>
                                                            <edit_label style='background-color: white;'
                                                                @update="update_title" :type="'Title'" :index="prompt_index"
                                                                :content="prompt.title" :languages="languages" />
                                                        </div>

                                                        <!-- Prompt Message -->
                                                        <div class='mb-2'>
                                                            <edit_label style='background-color: white;'
                                                                @update="update_message" :type="'Message'"
                                                                :index="prompt_index" :content="prompt.message"
                                                                :languages="languages" />
                                                        </div>
                                                        
                                                        <!-- Prompt Functional Buttons -->
                                                        <fieldset>
                                                            <legend>Buttons</legend>
                                                            <!-- Close Function -->
                                                            <v-switch v-model="prompt.buttons.close.enabled"
                                                                label="Close: close this prompts" hide-details />
                                                            <!-- Close Function Label -->
                                                            <edit_label v-if="prompt.buttons.close.enabled"
                                                                style='background-color: white;'
                                                                @update="update_button_label_close" :type="'Label'"
                                                                :index="prompt_index"
                                                                :content="prompt.buttons.close.label"
                                                                :languages="languages" />

                                                            <!-- Exit Function -->
                                                            <v-switch v-model="prompt.buttons.exit.enabled"
                                                                label="Exit: exits program" 
                                                                hide-details />
                                                            <edit_label v-if="prompt.buttons.exit.enabled"
                                                                style='background-color: white;'
                                                                @update="update_button_label_exit" :type="'Label'"
                                                                :index="prompt_index"
                                                                :content="prompt.buttons.exit.label"
                                                                :languages="languages" />

                                                            <!-- Restart Function -->
                                                            <v-switch v-model="prompt.buttons.restart.enabled"
                                                                label="Restart: reloads survey"
                                                                hide-details />
                                                            <edit_label v-if="prompt.buttons.restart.enabled"
                                                                style='background-color: white;'
                                                                @update="update_button_label_restart" :type="'Label'"
                                                                :index="prompt_index"
                                                                :content="prompt.buttons.restart.label"
                                                                :languages="languages" />

                                                            <!-- Dismiss Function -->
                                                            <v-switch v-model="prompt.buttons.dismiss.enabled"
                                                                label="Dismiss: never show again"
                                                                hide-details />
                                                            <edit_label v-if="prompt.buttons.dismiss.enabled"
                                                                style='background-color: white;'
                                                                @update="update_button_label_dismiss" :type="'Label'"
                                                                :index="prompt_index"
                                                                :content="prompt.buttons.dismiss.label"
                                                                :languages="languages" />

                                                        </fieldset>

                                                        <!-- Add Rule & Rule Trash Section -->
                                                        <div style="display:flex; flex-direction: row; margin-top: 15px;">
                                                            <!-- Add Rule Btn -->
                                                            <v-btn 
                                                                @click="add_rule(prompt)" 
                                                                color="primary"
                                                                small
                                                                depressed
                                                                class="ml-5 mt-3">
                                                                Add Rule
                                                            </v-btn>

                                                            <!-- Rule Trash Section -->
                                                            <div style="margin: 15px 20px 0 auto;">
                                                                <v-menu offset-y nudge-left='50'>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-btn
                                                                            x-small
                                                                            icon
                                                                            color="primary"
                                                                            dark
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                            :disabled="rule_trash.length === 0"
                                                                            >
                                                                            <div :class="$style.ruleTrashSection">
                                                                                <v-badge right>
                                                                                    <template v-slot:badge>
                                                                                        <span>{{rule_trash.length}}</span>
                                                                                    </template>
                                                                                    <svgIcon :src="trashIcon" />
                                                                                </v-badge>
                                                                                <span :class="$style.ruleTrashLabel">Rules Trash</span>
                                                                            </div>
                                                                        </v-btn>
                                                                    </template>
                                                                    <v-list v-if="rule_trash.length > 0">
                                                                        <draggable class="list-group" :list="rule_trash" :group="'rules'" >
                                                                            <v-list-item v-for="(item, index) in rule_trash" :key="'trash_prompt_' + prompt_index + 'rules_'+index">
                                                                                <div style="border-bottom: 1px solid lightgrey;">
                                                                                    <h3>Name: {{item.name}}</h3>
                                                                                </div>
                                                                            </v-list-item>
                                                                        </draggable>
                                                                    </v-list>
                                                                </v-menu>
                                                            </div>
                                                        </div>

                                                        <!-- Prompt Rule Draggable Section -->
                                                        <draggable class="list-group" :list="prompt.rules"
                                                            :group="'rules'" handle=".handle" 
                                                            :class="[{[$style.emptyPromptRuleWrapper]: prompt.rules.length == 0}, 'list-group']">
                                                            <template v-for="(rule,rule_index) in prompt.rules">
                                                                <div :key="'prompt_'+prompt_index+'_rule_'+rule_index"
                                                                    :class="$style.prompt_rule_item">

                                                                    <!-- Prompt Rule Draggable Icon -->
                                                                    <aside :class="[$style.promptRuleItemDragSection, 'handle']">
                                                                        <svgIcon :src="dragIcon" />
                                                                    </aside>

                                                                    <!-- Prompt Rule Draggable Expansion Panel -->
                                                                    <main :class="$style.promptRuleItemMainSection">
                                                                        <v-icon 
                                                                            @click="removePromptRule(prompt_index, rule_index);"
                                                                            color="black" 
                                                                            small 
                                                                            :class="$style.deleteIcon">
                                                                            fa fa-times-circle
                                                                        </v-icon>
                                                                        <v-expansion-panels>
                                                                            <v-expansion-panel class="custom-icon-rotation">
                                                                                <v-expansion-panel-header 
                                                                                    expand-icon="fas fa-angle-right"
                                                                                    style="background-color: lightgrey;">
                                                                                    <span style="font-size: 1.2rem; color: black;">{{rule.name}}</span>
                                                                                </v-expansion-panel-header>

                                                                                <v-expansion-panel-content :class="$style.promptRuleExpansionContentSection">
                                                                                    <div>
                                                                                        <!-- Rule Name Input -->
                                                                                        <p style="margin-bottom: 0px">Rule Name</p>
                                                                                        <v-text-field 
                                                                                            hide-details
                                                                                            outlined
                                                                                            dense
                                                                                            background-color="white"
                                                                                            v-model="rule.name"
                                                                                            />
                                                                                        <div v-if="rule.name" style="position:relative;">

                                                                                            <!-- Prompt's Rule's Condition Add Btn + its Trash -->
                                                                                            <div style="display: flex;">
                                                                                                <v-btn 
                                                                                                    small
                                                                                                    depressed
                                                                                                    @click="add_condition(rule)"
                                                                                                    class='my-3'
                                                                                                    color="primary">
                                                                                                    Add Condition
                                                                                                </v-btn>
                                                                                                <div style="margin: 15px 20px 0 auto;">
                                                                                                    <v-menu offset-y nudge-left='50'>
                                                                                                        <template v-slot:activator="{ on, attrs }">
                                                                                                            <v-btn
                                                                                                                x-small
                                                                                                                icon
                                                                                                                color="primary"
                                                                                                                dark
                                                                                                                v-bind="attrs"
                                                                                                                v-on="on"
                                                                                                                :disabled="condition_trash.length === 0"
                                                                                                                >
                                                                                                                <div :class="$style.conditionTrashSection">
                                                                                                                    <v-badge right>
                                                                                                                        <template v-slot:badge>
                                                                                                                            <span>{{condition_trash.length}}</span>
                                                                                                                        </template>
                                                                                                                        <svgIcon :src="trashIcon" />
                                                                                                                    </v-badge>
                                                                                                                    <span :class="$style.conditionTrashLabel">Rules Trash</span>
                                                                                                                </div>
                                                                                                            </v-btn>
                                                                                                        </template>
                                                                                                        <v-list v-if="condition_trash.length > 0">
                                                                                                            <draggable class="list-group" 
                                                                                                                :list="condition_trash" 
                                                                                                                :group="'condition'" >
                                                                                                                <v-list-item 
                                                                                                                    v-for="(item, index) in condition_trash" 
                                                                                                                    :key="'trash_prompt_' + prompt_index + 'rules_'+rule_index + 'condition_' + index">
                                                                                                                    <div style="border-bottom: 1px solid lightgrey;">
                                                                                                                        <h3>Condition #{{index + 1}}: {{item.name}}</h3>
                                                                                                                    </div>
                                                                                                                </v-list-item>
                                                                                                            </draggable>
                                                                                                        </v-list>
                                                                                                    </v-menu>
                                                                                                </div>
                                                                                            </div>

                                                                                            <!-- Prompt's Rule's Conditon Draggable Section -->
                                                                                            <draggable class="list-group"
                                                                                                :list="rule.conditions"
                                                                                                :group="'condition'" 
                                                                                                handle=".handle"
                                                                                                :class="[{[$style.emptyPromptRuleConditionWrapper]: rule.conditions.length == 0}, 'list-group']"
                                                                                                >
                                                                                                <template
                                                                                                    v-for="(condition, condition_index) in rule.conditions">
                                                                                                    <div :key="'prompt_'+prompt_index+'_rule_'+rule_index+'_condition_'+condition_index"
                                                                                                        :class="[$style.condition_item]">
                                                                                                        
                                                                                                        <!-- Prompt's Rule's Conditon Draggable Icon -->
                                                                                                        <aside :class="[$style.promptRuleConditionDragSection, 'handle']">
                                                                                                            <svgIcon :src="dragIcon" />
                                                                                                        </aside>

                                                                                                        <!-- Prompt's Rule's Conditon Draggable Expansion Panels -->
                                                                                                        <main :class="$style.promptRuleConditionMainSection">
                                                                                                            <v-icon 
                                                                                                                @click="removePromptRuleCondition(prompt_index, rule_index, condition_index);"
                                                                                                                color="black" 
                                                                                                                small 
                                                                                                                :class="$style.deleteIcon">
                                                                                                                fa fa-times-circle
                                                                                                            </v-icon>
                                                                                                            <v-expansion-panels>
                                                                                                                <v-expansion-panel class="custom-icon-rotation">
                                                                                                                    <v-expansion-panel-header expand-icon="fas fa-angle-right">
                                                                                                                        <span>
                                                                                                                            Condition: #{{condition_index + 1}} 
                                                                                                                            <i>(ALL conditions required to trigger rule)</i>
                                                                                                                        </span>
                                                                                                                    </v-expansion-panel-header>

                                                                                                                    <v-expansion-panel-content :class="$style.promptRuleConditionExpansionContentSection">
                                                                                                                        <div style="width: 50%" >

                                                                                                                            <!-- Condition Name Input -->
                                                                                                                            <span>Condition Name</span>
                                                                                                                            <v-text-field
                                                                                                                                v-model="condition.name"
                                                                                                                                outlined
                                                                                                                                dense
                                                                                                                                />

                                                                                                                            <!-- Condition Reference Source input -->
                                                                                                                            <span>
                                                                                                                                Reference Source
                                                                                                                                <v-tooltip right color="black"> 
                                                                                                                                    <template v-slot:activator="{on, attrs}">
                                                                                                                                        <v-icon style="margin-left: 5px" 
                                                                                                                                            color="black"
                                                                                                                                            small 
                                                                                                                                            v-bind="attrs" 
                                                                                                                                            v-on="on">fas fa-info-circle</v-icon>
                                                                                                                                    </template>
                                                                                                                                    <span>
                                                                                                                                        Reference source is the question that relates to the rule or condition mentioned.
                                                                                                                                    </span>
                                                                                                                                </v-tooltip>
                                                                                                                            </span>
                                                                                                                            <v-select
                                                                                                                                outlined
                                                                                                                                dense
                                                                                                                                :items="list_types"
                                                                                                                                v-model='condition.ref_type' />
                                                                                                                        
                                                                                                                            <!-- Condition Question Selection - v-if: ref_type = question -->
                                                                                                                            <template
                                                                                                                                v-if="condition.ref_type=='question'">
                                                                                                                                <v-switch
                                                                                                                                    v-model="condition.clear_on_close"
                                                                                                                                    label="Clear on close" />
                                                                                                                                
                                                                                                                                <span>Question Selection</span>
                                                                                                                                <v-select
                                                                                                                                    :items="list_questions"
                                                                                                                                    outlined
                                                                                                                                    v-model='condition.ref_id'
                                                                                                                                    @change="resetRefQuestionDependables(condition)"
                                                                                                                                    label="Question" />
                                                                                                                                
                                                                                                                                <!-- Range Restricted Switch -->
                                                                                                                                <template v-if="isQuestionOfNumberTyp(condition.ref_id)">
                                                                                                                                    <v-row class="mx-1">
                                                                                                                                        <!-- Apply Range Constraints -->                                                           
                                                                                                                                        <v-sheet class="d-inline-flex mx-12 mb-3 px-3 elevation-1">
                                                                                                                                            <v-sheet>
                                                                                                                                                <p style="margin-bottom: 0px">Range Restricted</p>
                                                                                                                                                <v-switch
                                                                                                                                                    v-model="condition.number_range_restricted"
                                                                                                                                                    @change="updateAdvancedFunctionContent(condition, $event)"
                                                                                                                                                    :true-value="true"
                                                                                                                                                    :false-value="false"
                                                                                                                                                    class="justify-center"
                                                                                                                                                    >
                                                                                                                                                        <template v-slot:label>
                                                                                                                                                            <v-tooltip top color="black"> 
                                                                                                                                                                <template v-slot:activator="{on, attrs}">
                                                                                                                                                                    <v-icon class='ml-1'
                                                                                                                                                                        color="#000000"
                                                                                                                                                                        small 
                                                                                                                                                                        v-bind="attrs" 
                                                                                                                                                                        v-on="on">fas fa-info-circle</v-icon>
                                                                                                                                                                </template>
                                                                                                                                                                <span>Bound Value Inclusive!</span>
                                                                                                                                                            </v-tooltip>
                                                                                                                                                        </template>                                                                                                                                
                                                                                                                                                </v-switch>
                                                                                                                                            </v-sheet>
                                                                                                                                            <template v-if="condition.number_range_restricted">
                                                                                                                                                <v-sheet class="ml-6">
                                                                                                                                                    <p style="margin-bottom: 0px;">Lower Bound</p>
                                                                                                                                                    <v-text-field
                                                                                                                                                            v-model="condition.range_bound.lower_bound_limit"
                                                                                                                                                            @change="onBoundChange(condition, 'lower_bound_limit', $event)"
                                                                                                                                                            type="number" 
                                                                                                                                                            min="0"
                                                                                                                                                            :max="218"
                                                                                                                                                            solo-inverted
                                                                                                                                                        />
                                                                                                                                                </v-sheet>
                                                                                                                                                <v-sheet class="ml-9">
                                                                                                                                                    <p style="margin-bottom: 0px;">Upper Bound</p>
                                                                                                                                                    <v-text-field 
                                                                                                                                                            v-model="condition.range_bound.upper_bound_limit"
                                                                                                                                                            @change="onBoundChange(condition, 'upper_bound_limit', $event)"
                                                                                                                                                            type="number" 
                                                                                                                                                            min="0"
                                                                                                                                                            :max="218"                                                            
                                                                                                                                                            solo-inverted
                                                                                                                                                        />
                                                                                                                                                </v-sheet>
                                                                                                                                            </template>
                                                                                                                                        </v-sheet>
                                                                                                                                    </v-row>                                                       
                                                                                                                                </template> 
                                                                                                                                
                                                                                                                                <template v-if="condition.ref_id!=null">
                                                                                                                                    <span>Group Selection</span>
                                                                                                                                    <v-select                                                                                                                                
                                                                                                                                        outlined
                                                                                                                                        :items="list_group(condition.ref_id)"
                                                                                                                                        v-model="condition.group_id"
                                                                                                                                        label="Group" />
                                                                                                                                </template>                                                                                                                               
                                                                                                                                <template v-if="condition.ref_id!=null && condition.group_id!=null">                                                                                                                                
                                                                                                                                    <span>Select an Operator</span>
                                                                                                                                    <v-select outlined v-if="condition.ref_id" :items="condition_operator[questionMap[condition.ref_id].config.type]" v-model="condition.operator" @change="resetOperatorPropertyContext(condition)"/>
                                                                                                                                    <p :class="$style.ruleInputLabel">
                                                                                                                                        <v-tooltip right color="black">
                                                                                                                                            <template v-slot:activator="{on, attrs}">
                                                                                                                                                <v-icon class='ml-2'
                                                                                                                                                    color="black"
                                                                                                                                                    small
                                                                                                                                                    v-bind="attrs" 
                                                                                                                                                    v-on="on">fas fa-info-circle</v-icon>
                                                                                                                                            </template>
                                                                                                                                            <span v-html="condition_operator_tooltip[condition.operator]"></span>
                                                                                                                                        </v-tooltip>
                                                                                                                                    </p>
                                                                                                                                    <v-text-field v-if="condition.operator!=='has_selected'" type='text' v-model="condition[condition.operator]" outlined :clearable="true"/>
                                                                                                                                    <template v-if="(condition.ref_id!=null && condition.group_id!=null && condition.input_id!==null) || condition.operator==='has_selected'">
                                                                                                                                        <span>Has Selected?</span>
                                                                                                                                        <v-select
                                                                                                                                            v-if="condition.ref_id!=null && condition.group_id!=null"
                                                                                                                                            outlined
                                                                                                                                            :items="list_input(condition.ref_id, condition.group_id)"
                                                                                                                                            v-model="condition.input_id"
                                                                                                                                            label="Has selected" />
                                                                                                                                    </template>
                                                                                                                                </template>

                                                                                                                                <span>Advanced: Function Wrapper (question, questionMap, language) - remember to consider null values</span>
                                                                                                                                <v-textarea
                                                                                                                                    outlined
                                                                                                                                    v-model="condition.advanced" />
                                                                                                                            </template>
                                                                                                                        </div>
                                                                                                                    </v-expansion-panel-content>
                                                                                                                </v-expansion-panel>
                                                                                                            </v-expansion-panels>
                                                                                                        </main>
                                                                                                    </div>
                                                                                                </template>
                                                                                            </draggable>
                                                                                        </div>
                                                                                    </div>
                                                                                </v-expansion-panel-content>
                                                                            </v-expansion-panel>
                                                                        </v-expansion-panels>
                                                                    </main>
                                                                </div>
                                                            </template>
                                                        </draggable>
                                                    </div>

                                                </div>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </main>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
    import draggable from "vuedraggable";
    import edit_label from "./edit_labels.vue";

    import svgIcon from '@/components/svg/svg_icon.vue';
    import dragIcon from '@/assets/images/icons/drag.svg';
    import trashIcon from '@/assets/images/icons/trash.svg';
    import OperatorConfig from '@/components/Survey/helpers/OperatorConfig.js';

    export default {
        name: 'prompt-editor',
        props: {
            prompts: {
                type: Array,
                required: true
            },
            languages: {
                type: Array,
                required: true
            },
            questions: {
                type: Array,
                required: true
            },
            questionMap: {
                type: Object,
                required: true
            },
            developerMode: {
                type: Boolean,
                required: true
            }
        },
        components: {
            draggable,
            edit_label,
            svgIcon
        },
        created: function () {
            this.items = this.$root.unlink(this.prompts);
            for (let i = 0; i < this.items.length; i++) {
                var item = {...this.items[i]};
                for (let button_name in item.buttons) {
                    var button = item.buttons[button_name];
                    if (typeof button.label.length == 'number') {
                        button.label = {}
                    }
                }
                
                let rules = item.rules;
                for(let r=0; r<rules.length; r++){
                    let ruleConditionSet = rules[r].conditions;
                    for(let c=0; c<ruleConditionSet.length; c++){
                        let condition = ruleConditionSet[c];
                        this.initConditionOperatorAndContent(condition);
                    }
                }
            }         
        },
        data: function () {
            return {
                items: null,
                prompt_trash: [],
                rule_trash: [],
                condition_trash: [],
                condition_operator: OperatorConfig.map_by_question_type,
                condition_operator_tooltip: OperatorConfig.condition_operator_tooltip
            }
        },
        methods: {
            add_prompt: function () {
                this.items.push({
                    name: null,
                    suppress: false,
                    onTrigger: null,
                    rules: [],
                    title: {},
                    message: {},
                    buttons: {
                        close: {
                            enabled: true,
                            label: {}
                        },
                        exit: {
                            enabled: false,
                            label: {}
                        },
                        restart: {
                            enabled: false,
                            label: {}
                        },
                        dismiss: {
                            enabled: false,
                            label: {}
                        }
                    }
                });
            },
            add_rule: function (prompt) {
                prompt.rules.push({
                    name: null,
                    conditions: []
                })
            },
            add_condition: function (rule) {
                rule.conditions.push({
                    name: null,
                    ref_type: 'question',
                    ref_id: null,
                    group_id: null,
                    input_id: null,
                    operator: null,
                    clear_on_close: true,
                    advanced: null,
                    number_range_restricted: false,
                    range_bound: {
                        lower_bound_limit: null,
                        upper_bound_limit: null
                    }
                })
            },

            list_group: function (question_id) {
                var question = this.questionMap[question_id];

                var list = [];
                for (let g = 0; g < question.config.groups.length; g++) {
                    var group = question.config.groups[g];
                    list.push({
                        text: 'Index: ' + group.id + (group.label.en ? ' - ' + group.label.en : ''),
                        value: group.id
                    })
                }
                return list;
            },
            list_input: function (question_id, group_id) {
                var question = this.questionMap[question_id];

                for (let g = 0; g < question.config.groups.length; g++) {
                    var group = question.config.groups[g];
                    if (group.id == group_id) {
                        break;
                    }
                }

                var inputs = group.inputs;

                var list = [];
                for (let i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    list.push({
                        text: input.label.en,
                        value: input.id
                    })
                }
                return list;
            },
            update_title: function (data) {
                this.items[data.index].title = data.values;
            },
            update_button_label_close: function (data) {
                this.items[data.index].buttons.close.label = data.values;
            },
            update_button_label_exit: function (data) {
                this.items[data.index].buttons.exit.label = data.values;
            },
            update_button_label_restart: function (data) {
                this.items[data.index].buttons.restart.label = data.values;
            },
            update_button_label_dismiss: function (data) {
                this.items[data.index].buttons.dismiss.label = data.values;
            },
            update_message: function (data) {
                this.items[data.index].message = data.values;
            },
            removePrompt: function(prompt_index) {
                this.prompt_trash.push(this.items[prompt_index]);
                this.items.splice(prompt_index, 1);
            },
            removePromptRule: function(prompt_index, rule_index) {
                this.rule_trash.push(this.items[prompt_index].rules[rule_index]);
                this.items[prompt_index].rules.splice(rule_index, 1);
            },
            removePromptRuleCondition: function(prompt_index, rule_index, condition_index){
                this.condition_trash.push(this.items[prompt_index].rules[rule_index].conditions[condition_index]);
                this.items[prompt_index].rules[rule_index].conditions.splice(condition_index, 1);
            },
            isQuestionOfNumberTyp: function(questionMapIdx=null){
                return questionMapIdx!==null ? this.questionMap[questionMapIdx].config.type==='Number' : false;
            },
            onBoundChange: function(condition, property, event){
                if (event){
                    condition.advanced = "let inputValue=question.value[1][1]; return inputValue!==null && (inputValue < " 
                            + (property==='lower_bound_limit' ? event : condition.range_bound.lower_bound_limit) 
                            + " || inputValue > " + (property==='upper_bound_limit' ? event : condition.range_bound.upper_bound_limit) + ")";
                }
                
                return false
            },
            updateAdvancedFunctionContent: function(condition, event){
                if (event===false){
                    condition.advanced = null;
                }
            },
            resetRefQuestionDependables: function(condition){
                if (condition.operator){
                    delete condition[condition.operator];
                    condition.operator = condition.group_id = condition.input_id = null;
                }
            },
            resetOperatorPropertyContext: function(condition){
                for(let i=0; i<OperatorConfig.list.length; i++){
                    if (condition[OperatorConfig.list[i]]===condition.operator){
                        continue;
                    }
                    if (condition[OperatorConfig.list[i]]!==undefined){
                        delete condition[OperatorConfig.list[i]];
                    }
                    if (condition.operator!=='has_selected'){
                        condition.input_id=null;
                    }                    
                }
                this.$forceUpdate();                
            },
            /* @Name: initConditionOperatorAndContent 
             * @Desc: Supports backward compatibility. Early SurveyEditor generated conditions did not have Operator selector defined. Rather Operator was obtained by property name contains/equals/less_than/etc
             */
            initConditionOperatorAndContent: function( condition ){
                if (condition.ref_type==='question'){
                    let refQuestionType = this.questionMap[condition.ref_id].config.type;
                    let feasibleOperatorSet = this.condition_operator[refQuestionType];
                    for (let i=0; i<feasibleOperatorSet.length; i++){
                        let operator = feasibleOperatorSet[i];
                        if (condition[operator]!==undefined && condition[operator]!==null){
                            condition.operator = operator;
                            break;
                        }
                        else if (condition.ref_id!==null && condition.group_id!==null && condition.input_id!==null){
                            condition.operator='has_selected';
                            break;
                        }
                    }
                }
            }
        },
        computed: {
            list_types: function () {
                return [{
                        text: 'question',
                        value: 'question'
                    },
                    {
                        text: 'context',
                        value: 'context'
                    }
                ]
            },
            list_questions: function () {
                var questions = [];
                for (let i = 0; i < this.questions.length; i++) {
                    var question = this.questions[i];
                    questions.push({
                        text: "ID: " + question.config.id + " " + question.config.body.en,
                        value: question.config.id
                    })
                }

                return questions
            },
            promptDeveloperMode: {
                get: function () {
                    return this.developerMode;
                },
                set: function (newValue) {
                    this.$emit('updatedDeveloperMode', newValue);
                }
            },
            dragIcon: function () {
                return dragIcon;
            },
            trashIcon: function () {
                return trashIcon;
            }
        },
        watch: {
            items: {
                deep: true,
                handler: function () {
                    
                    this.$emit('update', {
                        prompts: this.items
                    })
                }
            }
        }
    }
</script>

<style module>
    .ruleInputLabel {
        margin-bottom: 0px !important;
        font-size: 14px; 
        color: black;
    }

    .list_container {
        width: 98%;
        margin: 0 auto;
        padding-bottom: 15px;
    }

    .prompt_item, .prompt_rule_item, .condition_item {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        position: relative;
        margin: 15px 0px 15px 0px;
        background-color: inherit;
    }

    .promptItemDragSection, .promptRuleItemDragSection, .promptRuleConditionDragSection {
        cursor: grab;
        display: flex;
        flex-direction: column;
        text-align: center;
        width: 4.5%;
        background-color: #eeeeee;
        cursor: grab;
        justify-content: center;
    }

    .promptRuleItemDragSection, .promptRuleConditionDragSection {
        height: 65px;
    }

    .promptItemDragSection {
        height: 50px
    }

    .promptItemDragSection:active, .promptRuleItemDragSection:active, .promptRuleConditionDragSection:active {
        cursor: grabbing;
    }

    .promptItemDragSection span, .promptRuleItemDragSection span, .promptRuleConditionDragSection span {
        font-size: 10px;
        color: #82B1FF;
    }

    .promptItemMainSection, .promptRuleItemMainSection, .promptRuleConditionMainSection {
        width: 95.5%;
        position: relative;
    }

    .promptExpansionContentSection, .promptRuleExpansionContentSection, .promptRuleConditionExpansionContentSection {
        background-color: white;
        border-top: 1px solid #E5E5E5;
        padding-top: 15px;
    }

    .promptRuleExpansionContentSection {
        background-color: lightgrey;
    }

    .targetSurveyEditorTools {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: flex-end;
        padding: 20px 0;
    }

    .promptTrashSection, .ruleTrashSection, .conditionTrashSection {
        display: flex; 
        flex-direction: column; 
        align-items: center; 
        justify-content: center;
        cursor: pointer;
    }

    .promptTrashLabel, .ruleTrashLabel, .conditionTrashLabel {
        font-size: 8px; 
        color: black; 
        font-weight: 400; 
        text-transform: initial;
    }
    .deleteIcon {
        position: absolute; 
        top: -9px; 
        right: -5px; 
        z-index:2;
        cursor: pointer;
    }

    .emptyPromptWrapper, .emptyPromptRuleWrapper, .emptyPromptRuleConditionWrapper {
        border: 1px dashed silver;
        height: 50px;
        margin-top: 15px;
        padding-bottom: 15px;
    }

    .emptyPromptWrapper:after {
        content: 'Drag Prompts to here...';
        margin: 0 auto;
        vertical-align: -50%;
        text-align: center;
        padding: 0 15px;
    }

    .emptyPromptRuleWrapper:after {
        content: 'Drag Prompt Rule to here...';
        margin: 0 auto;
        vertical-align: -50%;
        text-align: center;
        padding: 0 15px;
    }

    .emptyPromptRuleConditionWrapper:after {
        content: 'Drag Prompt Rule Condition to here...';
        margin: 0 auto;
        vertical-align: -50%;
        text-align: center;
        padding: 0 15px;
    }
</style>